import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useState } from 'react';
import { canDeletePatientProfile } from './lib/can-delete-patient-profile';
import { useDeletePatientProfile } from './model';

interface Props {
  id?: string;
}

export const DeletePatientProfile: FC<Props> = ({ id }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { deleteProfile, isDeleting, error, clearError } = useDeletePatientProfile(id);

  if (!canDeletePatientProfile()) {
    return null;
  }

  const openDialog = () => {
    clearError();
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    if (isDeleting) {
      return;
    }
    clearError();
    setIsDialogOpen(false);
  };

  const handleConfirm = async () => {
    const isDeleted = await deleteProfile();
    if (isDeleted) {
      setIsDialogOpen(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="error"
        size="small"
        startIcon={<DeleteOutlineIcon />}
        onClick={openDialog}
        disabled={!id}
      >
        Удалить профиль
      </Button>

      <Dialog open={isDialogOpen} onClose={closeDialog} fullWidth maxWidth="sm">
        <DialogTitle>Удалить профиль?</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            {error && <Alert severity="error">{error}</Alert>}
            <Typography>Точно ли хотите удалить профиль?</Typography>
            <Typography variant="body2" color="text.secondary">
              Действие необратимо. Удаляются только профили без сессий и платежей.
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} disabled={isDeleting}>
            Отмена
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleConfirm}
            disabled={isDeleting || !id}
          >
            Удалить
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
